import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=4501d07d&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4501d07d')) {
      api.createRecord('4501d07d', component.options)
    } else {
      api.reload('4501d07d', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=4501d07d&", function () {
      api.rerender('4501d07d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Yjz536FajQ44/JS/ImageCarousel.vue"
export default component.exports